export const generateFilteredTransactionBatches = (
  transactionBatches,
  filterBy,
) => {
  if (!filterBy) return transactionBatches;
  return (transactionBatches || []).filter(
    (t) => t?.header?.pfp?.period === filterBy,
  );
};
